import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import HubspotForm from 'react-hubspot-form'
import { trackFromSubmission } from '../helpers/utils'

function EmbedHubSpotForm({
    onFormSubmission,
    shouldTrack = true,
    formName,
    portalId = '21994206',
    formId,
}) {
    const { executeRecaptcha } = useGoogleReCaptcha()

    const handleOnFormSubmission = () => {
        if (shouldTrack) {
            trackFromSubmission(formName)
            if (window.gtag) {
                window.gtag('event', 'conversion', {
                    send_to: 'AW-10868336784/wuxHCLnL-ooYEJDRtr4o',
                })
            }
        }
        if (onFormSubmission) onFormSubmission()
    }

    const handleFormReady = () => {
        const form = document.querySelector(`form[data-form-id="${formId}"]`)
        if (!form || !executeRecaptcha) return

        form.addEventListener('submit', async (e) => {
            // Avoid duplicate submission
            if (form.dataset.recaptchaChecked === 'true') return

            e.preventDefault()

            const token = await executeRecaptcha('hubspot_form')
            const res = await fetch('/api/verify-recaptcha', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ recaptchaToken: token }),
            })
            const { success, score } = await res.json()

            if (!success || score < 0.5) {
                alert('reCAPTCHA failed. Try again.')
                return
            }

            form.dataset.recaptchaChecked = 'true'
            form.submit()
        })
    }

    return (
        <HubspotForm
            portalId={portalId}
            formId={formId}
            onSubmit={handleOnFormSubmission}
            onReady={handleFormReady}
            loading={<div>Loading...</div>}
        />
    )
}

export default EmbedHubSpotForm

/**
 * Usage
* <EmbedHubSpotForm
    portalId="21994206"
    formId="bda6f6ae-9125-4d8a-b47e-d572680889a5"
    formName="Partner With Us"
/>
*/
